// Single source of truth for "where should Continue/Qualify navigation land" —
// used by both the Dashboard's "Save and continue" button and the sidebar's
// Qualify link, so a user who hasn't chosen a qualification path yet always
// sees the AURA/non-AURA choice screen instead of being dropped into a
// specific path (previously the AURA path was hardcoded as the default).
export const getQualifyEntryPath = ({ selectedPath, selectedProgram }) => {
	if (selectedProgram) return "/current-loan/submit";
	if (selectedPath === "non-aura") return "/current-loan/qualify/non-aura";
	if (selectedPath === "aura") return "/current-loan/qualify/aura";
	return "/current-loan/qualify/path-select";
};

// Every Dashboard section saved with its own Save button and unchanged since ("complete").
export const areDashboardSectionsComplete = (sectionStatuses) => {
	const values = Object.values(sectionStatuses || {});
	return values.length > 0 && values.every((status) => status === "complete");
};

// Where Qualify's final Continue lands: straight to Submit when the Dashboard is already
// complete, otherwise back to the Dashboard to finish it.
export const getPostQualifyStage = (sectionStatuses) =>
	areDashboardSectionsComplete(sectionStatuses) ? "submit" : "dashboard";

// Qualify is finished only once its last step is done: AURA after Panel D
// "Continue" (qualifyInputs.registered), Manual after "Register program &
// continue" (selectedProgram). Visiting Qualify alone does not complete it.
export const isQualifyComplete = ({ selectedPath, selectedProgram, qualifyInputs }) => {
	// resetQualifyProgress (Income Doc Type change) clears selectedProgram but not
	// qualifyInputs.registered, so AURA needs both.
	if (selectedPath === "aura") return !!selectedProgram && !!qualifyInputs?.registered;
	if (selectedPath === "non-aura") return !!selectedProgram;
	return false;
};
